export { ProductCard } from "./components/ProductCard";
export { getProductTiles } from "./components/Recommenders/utils";

import {
  AddItemToWishListDocument as AddItemToWishlistMutation,
  RemoveItemFromWishListDocument as RemoveItemFromWishListMutation,
  ProductCardDataFragmentDoc,
} from "./generated/graphql";

export const AddItemToWishListDocument = AddItemToWishlistMutation;
export const RemoveItemFromWishListDocument = RemoveItemFromWishListMutation;
export const ProductCardDataFragmentDcoument = ProductCardDataFragmentDoc;
